module.exports = __webpack_public_path__ + "static/img/ARAD-S4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD-S4.png
// module id = qDD/
// module chunks = 0